let pendingApi;

// Called only after the viewer has allowed external content.
export function loadYouTubeApi() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (pendingApi) return pendingApi;
  pendingApi = new Promise((resolve, reject) => {
    const previousReady = window.onYouTubeIframeAPIReady;
    const ready = () => {
      window.onYouTubeIframeAPIReady = previousReady;
      resolve(window.YT);
      if (typeof previousReady === 'function') previousReady();
    };
    window.onYouTubeIframeAPIReady = ready;
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    script.onerror = () => {
      if (window.onYouTubeIframeAPIReady === ready) window.onYouTubeIframeAPIReady = previousReady;
      script.remove();
      pendingApi = undefined;
      reject(new Error('Impossibile caricare il player YouTube'));
    };
    document.head.appendChild(script);
  });
  return pendingApi;
}
